// console.info('--Dependency--');

(function initHeader($) {

  //manage menu mobile
  $(document).on('click', '.nav-item.nav-item--has-children', function (event) {
    //reset all active item
    $(".nav-item").removeClass("active");
    //set current item as active
    $(this).addClass("active");

    $(this).first("i").addClass("btn-navitem-back");

    //set current item pasent as active hidding the a tag containing the menu description
    var parentId = "#" + $(this).data("parent");
    $(parentId).addClass("active");
    $(parentId + " > a.nav-link").addClass("d-none");

    //hidding all menu at the same level and its parents except the current active
    var level = $(this).data("level");
    if (!isNaN(level)) {
      $("#mobile-nav .nav-item[data-level=" + level + "]").not(".active").addClass("d-none");
      $("#mobile-nav .nav-item[data-level=" + (parseInt(level) - 1) + "]").not(".active").addClass("d-none");
      $("#mobile-nav .nav-item[data-level=" + (parseInt(level) - 2) + "]").not(".active").addClass("d-none");
    }

    event.stopPropagation();
  });

  $(document).on('click', '.btn-navitem-back', function (event) {
    //remove active from current menu selection li is the parent of the button back.

    $(this).removeClass("btn-navitem-back");
    var parent = $(this).closest("li");
    $(parent).removeClass("active");

    //show the parent of curret back selectopn
    var parentParentId = "#" + $(parent).data("parent");
    $(parentParentId).addClass("active");
    $(parentParentId + " > a.nav-link").removeClass("d-none");

    //show the menu at the same level of current active menu.
    var level = $(parent).data("level");
    if (!isNaN(level)) {
      $("#mobile-nav .nav-item[data-level=" + level + "]").removeClass("d-none");
    }
    event.stopPropagation();

  });

  $(document).on('click', '.nav-item:not(.nav-item--has-children)', function (event) {
    event.stopPropagation();
  });

  $("#main-nav").on("show.bs.collapse", function () {
    //reset menu displaying
    $("#mobile-nav .nav-item").removeClass("active");
    $("#mobile-nav .nav-item").removeClass("d-none");
    $("#mobile-nav a.nav-link").removeClass("d-none");
  });


  /* Calculate scroll on mobile menu */
  $("#main-nav").on("shown.bs.collapse", function () {
    var wHeight = $(window).height();
    var navbarHeight = $(".main-nav.navbar").height();
    var navbarLangHeight = $(".navbar-nav.langs-navbar-nav").height();
    var mobileMenuHeight = wHeight - navbarHeight - navbarLangHeight;

    $("#mobile-nav").css("height", mobileMenuHeight + "px");
    $("#mobile-nav").addClass("is-opened");
    $("body").addClass("mobile-menu-opened");
  });

  $("#main-nav").on("hide.bs.collapse", function () {
    $("#mobile-nav").addClass("is-opened");
    $("body").removeClass("mobile-menu-opened");
  });

  /* manage menu desktop */
  $(document).ready(function () {

    var timeOutConst;

    $('#main-nav .nav-link[data-submenu]').bind('mouseenter', function() {

      var that = this;
      $('.nav-link').removeClass('hovering');
      timeOutConst = setTimeout(function() {
        var $submenu = $(that).attr('data-submenu');
        $(that).addClass('hovering');
        $('#' + $submenu).addClass('open');
      }, 400);
    });

    $('#main-nav .nav-link[data-submenu]').bind('mouseleave', function() {
      var $submenu = $(this).attr('data-submenu');
      $('#' + $submenu).removeClass('open');
      clearInterval(timeOutConst);
    });

    $("#main-nav .navbar-nav, .service-list.navbar-submenu").bind('mouseleave', function () {
      var openedNavbarSubmenu = $('.service-list.navbar-submenu:not(\'.open\')').filter(function(idx){
        return $(this).css('display') !== 'none';
      });

      if($('.service-list.navbar-submenu.open').length === 0 && openedNavbarSubmenu.length === 0) {
        $('.nav-link').removeClass('hovering');
      }

    });
  });

  //manage link via javascript ragoo issues
  $("a.js-redirect").click(function (e) {
    e.preventDefault();
    window.location.href = $(this).data("href");
  });

}(jQuery));

(function ($) {

  $(document).ready(function () {
    var $countdown = $('.countdown-number');
    var number = $countdown.length && parseInt($countdown.text());
    if (!isNaN(number)) {
      var numberStringRepresentation = number.toLocaleString('it-IT');
      var lastDigit = numberStringRepresentation.split('').pop();
      var $span = $('<span />', {
        text: lastDigit
      });
      $countdown
        .attr({
          'data-prev-digit': lastDigit - 1,
          'data-digit': lastDigit,
        })
        .text(numberStringRepresentation.slice(0, -1))
        .append($span);
    }

    var breakpointMobile = 991,
      isChanging = false,
      isFiltered = false;
    //Slick slide on hp hero

    var heroSlider = $('.sc-hero--slider');

    if (heroSlider.length > 0) {

      heroSlider.on('init', function (event, slick) {
        if ($(slick.$slides.get(0)).has('video').length > 0) {
          $(slick.$slides.get(0)).find('video')[0].play();
        }
      });

      heroSlider.slick({
        arrows: true,
        dots: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              arrows: false,
              dots: true
            }
          }
        ]
      });

      heroSlider
        .on('breakpoint', function (event, slick) {
          if (!isChanging) {
            isChanging = true;
            if (slick.activeBreakpoint && slick.activeBreakpoint <= breakpointMobile) {
              if (!isFiltered) {
                slick.slickFilter(':not(.hide-on-mobile)');
                isFiltered = true;
              }
            } else {
              if (isFiltered) {
                slick.slickUnfilter();
                isFiltered = false;
              }
            }
            isChanging = false;
          }
        })
        .on('beforeChange', function (event, slick, currentSlide) {
          if ($(slick.$slides.get(currentSlide)).has('video').length > 0) {
            $(slick.$slides.get(currentSlide)).find('video')[0].pause();
          }
        })
        .on('afterChange', function (event, slick, currentSlide) {
          if ($(slick.$slides.get(currentSlide)).has('video').length > 0) {
            $(slick.$slides.get(currentSlide)).find('video')[0].play();
          }
        });
    }
  });

}(jQuery));

(function ($) {
  $(document).ready(function () {
    var $promoCarousel = $('#promo-carousel');
    if ($promoCarousel.length > 0) {
      $promoCarousel.slick({
        arrows: false,
        dots: true,
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: false,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              centerPadding: '30px',
              initialSlide: 1,
              slidesToShow: 2,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
    }
  });
}(jQuery));

(function ($) {
  $(document).ready(function () {
    var $infoCarousel = $('#info-carousel');
    if ($infoCarousel.length > 0) {
      $infoCarousel.slick({
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        adaptiveHeight: true
      });
    }
  });
}(jQuery));

/**
 * Script globale
 *
 * @requires ./dep.js
 * @requires ../Feature/Header/Scripts/header.js
 * @requires ../Feature/HeroBanner/Scripts/hero-banner.js
 * @requires ../Feature/PromoCarousel/Scripts/promo-carousel.js
 * @requires ../Feature/InfoCarousel/Scripts/info-carousel.js
 */

function showSpinner(){
  $("body").prepend("<div id='gnv-spinner-wrapper'><div class='lds-spinner-wrapper'><div class='lds-spinner'><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div></div></div>");
}

function hideSpinner(){
  $("#gnv-spinner-wrapper").remove();
}

$(document).ready(function(){

  $(document).ajaxStart(function() {
    showSpinner();
  });
  $(document).ajaxComplete(function() {
    hideSpinner();
  });

  checkFixedMobileBox();
  $(window).on('scroll resize', checkFixedMobileBox);

  function checkFixedMobileBox(){
    var selector = $('.fixed-bottom-mobile');
    if(selector.length > 0){
      var footerSelector = $('footer');
      if(selector.css('position') === 'fixed' && selector.outerHeight() > 0) {
        if(footerSelector.css('padding-bottom') !== (selector.outerHeight() + 'px')) {
          footerSelector.css('padding-bottom', selector.outerHeight());
        }
      } else {
        if(footerSelector.css('padding-bottom') !== '0px') {
          footerSelector.css('padding-bottom', 0);
        }
      }
    }
  }
});


$(document).ready(function () {
    var galleryCarousel = $('.sc-gallery-carousel');
    var galleryThumb = $('.sc-gallery-thumbnail');

    if(galleryCarousel.length > 0){
        galleryCarousel.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,
            asNavFor: '.sc-gallery-thumbnail',
            adaptiveHeight: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false
                    }
                }
            ]
        });
    }

    if(galleryThumb.length > 0){
        galleryThumb.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '.sc-gallery-carousel',
            dots: true,
            arrows: false,
            centerMode: true,
            focusOnSelect: true,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }

    var lightBoxModal = $('#lightBoxModal');
    lightBoxModal.on('show.bs.modal', function () {
        var srcImg = galleryCarousel.find('.slick-slide.slick-active .image-container').attr('data-src');
        var titleImg = galleryCarousel.find('.slick-slide.slick-active .image-container').attr('data-title');
        lightBoxModal.find('img.target-modal-image').attr('src', srcImg);
        lightBoxModal.find('#titleLightBoxModal').html(titleImg);
    });
});
(function ($) {
  $(document).ready(function () {
    var bpMobile = 991;
    var switchMobileClassEl = $('.js-switchMobileClass');
    if(switchMobileClassEl.length > 0) {
      switchMobileClass(switchMobileClassEl, bpMobile);

      $(window).on('resize', function(){
        switchMobileClassEl = $('.js-switchMobileClass');
        switchMobileClass(switchMobileClassEl, bpMobile);
      });
    }

    function initCarousel(el){
      if (el.length > 0) {
        el.slick({
          arrows: false,
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1
          // centerMode: true
        });
      }
    }
    function destroyCarousel(el) {
      el.slick('unslick');
    }

    function switchMobileClass(el, bpMobile){
      var DOMwidth = $(document).outerWidth();
      el.each(function(){
        var elCurrent = $(this);
        if(DOMwidth <= bpMobile && !elCurrent.hasClass('mobile')) {
          elCurrent.addClass('mobile');
          if(elCurrent.hasClass('el--mobile-carousel')){
            initCarousel(elCurrent);
          }
        } else if(DOMwidth > bpMobile && elCurrent.hasClass('mobile')) {
          elCurrent.removeClass('mobile');
          if(elCurrent.hasClass('el--mobile-carousel') && elCurrent.hasClass('slick-initialized')){
            destroyCarousel(elCurrent);
          }
        }
      });
    }
  });
}(jQuery));

(function ($) {
  $(document).ready(function () {
    //manage account dropdown
    $('.gnv-account-profile.dropdown-menu').on('click', function (e) {
      e.stopPropagation();
    });

    // manage account
    // this is the id of the form
    $("#account-menu").on("click", "#btnMyGnvLogin", function (e) {

      var form = $(this).closest("form");
      var url = form.attr('action');

      $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(),
        success: function (data) {
          $("#account-menu").html(data);
        },
        error: function (data) {
          $("#account-menu").html(data.responseText);
        }
      });

      e.preventDefault();
    });

    $("#account-menu").on("submit", "#frmLogout", function (e) {

      var form = $(this);
      var url = form.attr('action');

      $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(),
        success: function (data) {
          location.reload();
        },
        error: function (data) {
          $("#account-menu").html(data.responseText);
        }
      });

      e.preventDefault();

    });
  });
}(jQuery));

(function ($) {
  $(document).ready(function () {
    var $offerteTraghettiCarousel = $('.ferry-offers');
    if (!$offerteTraghettiCarousel.length) {
      return;
    }
      $offerteTraghettiCarousel.slick({
          arrows: false,
          dots: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: false,
          responsive: [
          {
              breakpoint: 1024,
              settings: {
                  centerPadding: '30px',
                  initialSlide: 1,
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  dots: true
              }
          },
          {
              breakpoint: 768,
              settings: {
                  slidesToShow: 1,
                  slidesToScroll: 1
              }
          },
          {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
          }
      ]
    });
  });
}(jQuery));

(function ($) {
  $(document).ready(function () {

    $("#frmCustomerCareContainer form button").click(function (event) {

      event.preventDefault();

      var form = $("#frmCustomerCareContainer form")[0];
      var url = form.action;
      $.ajax({
        type: "POST",
        url: url,
        data: new FormData(form),
        enctype: "multipart/form-data",
        processData: false,
        contentType: false,
        success: function (data) {
          $("#frmCustomerCareContainer").html(data);
        },
        error: function (data) {
          $("#frmCustomerCareContainer").html(data.responseText);
        }
      });
    });
  });
}(jQuery));

// console.info('Footer');

$(document).ready(function () {
  $(window).on('resize load', function () {
    var win = window;
    if (win.innerWidth < 576) {
      $('.footer').find('.togglable').addClass('collapse');
      $('.footer').find('.togglable').each(function () {
        $(this).attr('id', $(this).attr('data-id'));
      });
      $('.footer').find('.togglable').removeAttr('data-id');
    } else {
      $('.footer').find('.togglable').removeClass('collapse');
      $('.footer').find('.togglable').each(function () {
        $(this).attr('data-id', $(this).attr('id'));
      });
      $('.footer').find('.togglable').removeAttr('id');
    }
  });

  if ($('.footer .togglable').length > 0) {
    $('.footer .togglable').on('shown.bs.collapse', function () {
      $(this).parent().find('.title').find('i').removeClass('gnv-icon-arrow-down');
      $(this).parent().find('.title').find('i').addClass('gnv-icon-arrow-up');
    });

    $('.footer .togglable').on('hidden.bs.collapse', function () {
      $(this).parent().find('.title').find('i').addClass('gnv-icon-arrow-down');
      $(this).parent().find('.title').find('i').removeClass('gnv-icon-arrow-up');
    });
  }
});

function SwitchToLanguage(newLanguage, currentLanguage, redirectUrl) {
    var ajaxPost = function (responseFunction, sender) {
        var token = $('#_CRSFform input[name=__RequestVerificationToken]').val();
        $.ajax({
            type: "POST",
            url: "/api/feature/language/changelanguage",
            cache: false,
            headers: { "__RequestVerificationToken": token },
            contentType: "application/json; charset=utf-8",
            data: "{\"NewLanguage\":\"" + newLanguage + "\", \"CurrentLanguage\":\"" + currentLanguage + "\"}",
            success: function (data) {
                if (responseFunction != null) {
                    responseFunction(data, true, sender);
                }
            },
            error: function (data) {
                if (responseFunction != null) {
                    responseFunction(data, false, sender);
                }
            }
        });
    };

    ajaxPost(function (data, success, sender) {
        window.location = redirectUrl;
    });
    return false;
}

document.addEventListener("DOMContentLoaded", function () {
  (function () {
    var STICKY_THRESHOLD = 100;

    var mainNav = document.querySelector('.main-nav.navbar');
    mainNav.classList.add('mainNavBar__sticky');

    var isWidgetOpen = false;

    function observeClassChange() {
      var targetElement = document.getElementById('main-container');

      function handleClassChange() {
        var hasClass = targetElement.classList.contains('slide-up');
        var bw = document.querySelector('.mat-tab-body-wrapper');
        var bd = document.querySelector('.booking-widget-backdrop');
        var bodyHeight = document.querySelector('body').scrollHeight;
        if (hasClass) {
          bw.style.backgroundColor = "#fff";
          bw.style.zIndex = "2";
          bd.style.zIndex = "1";
          bd.style.height = bodyHeight + "px";
          isWidgetOpen = true;
        } else {
          bw.style.backgroundColor = "";
          window.scrollTo(0, 0);
          isWidgetOpen = false;
        }
      }

      var lastClassState = targetElement.className;

      setInterval(function () {
        var currentClassState = targetElement.className;
        if (currentClassState !== lastClassState) {
          handleClassChange();
          lastClassState = currentClassState;
        }
      }, 500);
    }

    function addGnvLogo() {
      var logo = document.querySelector('.navbar-brand');
      var target = document.querySelector('.sc-hero--booking-widget.internal-page.fixedOnScroll');

      if (logo && target) {
        if (!target.querySelector('.logo-clone')) {
          var logoClone = logo.cloneNode(true);
          logoClone.classList.add('logo-clone');
          target.insertBefore(logoClone, target.firstChild);
        }
      }
    }

    function removeGnvLogo() {
      var target = document.querySelector('.sc-hero--booking-widget.internal-page.fixedOnScroll');
      if (target) {
        var clonedLogo = target.querySelector('.logo-clone');
        if (clonedLogo) {
          target.removeChild(clonedLogo);
        }
      }
    }

    function hasOpenClass() {
      var elements = document.querySelectorAll('#main-container .mainNavBar__sticky .navbar-submenu');
      for (var i = 0; i < elements.length; i++) {
        if (elements[i].classList.contains('open')) {
          return true;
        }
      }
      return false;
    }

    function checkWindowWidth() {
      return window.innerWidth > 767;
    }

    window.addEventListener('load', function () {
      checkWindowWidth();
    });

    window.addEventListener('resize', function () {
      checkWindowWidth();
    });

    function addFixedClassOnScroll() {
      var bookingWidget = document.querySelector('.sc-hero--booking-widget');
      var newDiv = document.createElement('div');
      newDiv.classList.add('placeholderBookingWidget');
      newDiv.style.height = bookingWidget.offsetHeight + 'px';
      newDiv.style.width = '100%';
      newDiv.style.display = 'none';
      bookingWidget.parentNode.insertBefore(newDiv, bookingWidget.parentNode.firstChild);
      var mainNav = document.querySelector('.main-nav.navbar');
      mainNav.classList.add('mainNavBar__sticky');

      if (bookingWidget && window.innerWidth >= 769) {
        observeClassChange();
        window.addEventListener('scroll', function () {
          if (!hasOpenClass() && !isWidgetOpen) {
            if (window.scrollY >= STICKY_THRESHOLD) {
              toggleNavbar(false);
              bookingWidget.classList.add('fixedOnScroll');
              newDiv.style.display = 'block';
              addGnvLogo();
            }
            if (window.scrollY < STICKY_THRESHOLD) {
              toggleNavbar(true);
              removeGnvLogo();
              newDiv.style.display = 'none';
              bookingWidget.classList.remove('fixedOnScroll');

            }
          }


          if (isWidgetOpen) {
            toggleNavbar(true);
            removeGnvLogo();
            newDiv.style.display = 'none';
            bookingWidget.classList.remove('fixedOnScroll');
          }
        });
      }
    }

    function toggleNavbar(visible) {
      if (!visible) {
        mainNav.classList.add('hidden');
      } else {
        mainNav.classList.remove('hidden');
      }
    }

    function hasPtHomeClass() {
      return document.body.classList.contains('pt-home');
    }

    function hasBookingWidget() {
      return document.querySelector('.sc-hero--booking-widget');
    }

    if (!hasPtHomeClass()) {
      if (hasBookingWidget()) {
        setTimeout(function () {
          addFixedClassOnScroll();
        }, 2000);
      }
    }

  })();
});

(function ($) {
    $(document).ready(function () {
      var arrowDownExists = false;

      function calculateAndSetMaxHeight() {
        var closeButton = $('.telephones__close');
        var title = $('.telephones__text.--title');
        var subtitle = $('.telephones__text.--subtitle');
        var list = $('.telephones__list');
        var totalHeight = closeButton.height() + title.height() + subtitle.height();
        list.css('max-height', 'calc(100vh - ' + (totalHeight + 140) + 'px)');
      }

      function insertArrowDown() {
        if (!isMobile()) {
          if (!arrowDownExists) {
            var phoneLink = $('.main-nav .container-fluid .cc-info-box .phone-link span');
            var icon = $('<i></i>').addClass('gnv-icon gnv-icon-arrow-down ml-3 toggleTelephones');
            icon.css('cursor', 'pointer');
            icon.css('font-size', '1.6rem');
            if (phoneLink.length > 0) {
              // var genitore = phoneLink.parent();
              icon.insertAfter(phoneLink);
              arrowDownExists = true;
            }
          }
        }
      }

      function isMobile() {
        var windowWidth = $(window).width();
        return windowWidth < 992;
      }

      function removeArrowDown() {
        if (arrowDownExists && isMobile()) {
          var iconDown = $('.main-nav .container-fluid .cc-info-box .phone-link i.gnv-icon.gnv-icon-arrow-down');
          if (iconDown.length > 0) {
            iconDown.remove();
            arrowDownExists = false;
          }
        }
      }

      function preventDefaultOnTelephoneClick() {
        var telephoneLink = $('.main-nav .container-fluid .cc-info-box a.phone-link');
        if (telephoneLink.length > 0) {
          telephoneLink.on('click', function (e) {
            e.preventDefault();
          });
        }
      }

      function toggleTelephonesVisibility() {
        var telephones = document.getElementById('telephones');
        if (telephones) {
          if (telephones.classList.contains('visible')) {
            telephones.classList.remove('visible');
          } else {
            telephones.classList.add('visible');
          }
        }
      }

      function telephoneNumberClick() {
        var phoneLink = $(this).find('a').attr('href');

        if (isMobile()) {
          window.location.assign(phoneLink);
        }
        else {
          var changeFriendlyPhoneNumber = $(this).find('.--telephoneNumber').text();

          var phoneLinkSpan = $('.main-nav .container-fluid .cc-info-box .phone-link span');
          phoneLinkSpan.text(changeFriendlyPhoneNumber);

          var phoneFooter = $('.footer .social-footer-wrap  .container .social-footer .box .need-help .gnv-chip .gnv-text #contact-info');
          var phoneSpilt = phoneLink.split(":");
          phoneFooter.text(phoneSpilt[1]);
        }
      }
      function onWindowResize() {
        calculateAndSetMaxHeight();
        insertArrowDown();
        removeArrowDown();
      }

      function init() {
        
        var checkVisible = document.getElementById('telephones');
        if (checkVisible) {
          calculateAndSetMaxHeight();

          insertArrowDown();
          removeArrowDown();
          preventDefaultOnTelephoneClick();
          var toggleButtons = $('.toggleTelephones');
          var infoBox = $('.cc-info-box');

          if (toggleButtons.length > 0 && infoBox.length > 0) {
            infoBox.on('click', toggleTelephonesVisibility);

            //toggleButtons.each(function () {
            //  $(this).on('click', toggleTelephonesVisibility);
            //});
            $(".telephones__listItem").each(function () {
              $(this).on('click', telephoneNumberClick);
            });
          }

          $(window).on('resize', onWindowResize);

          var phoneLink = infoBox.find('a').attr('href');
          var phoneFooter = $('.footer .social-footer-wrap  .container .social-footer .box .need-help .gnv-chip .gnv-text #contact-info');
          var phoneSpilt = phoneLink.split(":");
          phoneFooter.text(phoneSpilt[1]);

          

        }
      }

      init();

    });
}(jQuery));

$(document).ready(function () {
  $(window).on('resize load', function () {
    var win = window;
    if (win.innerWidth < 576) {
      $('.left-side-links').find('.togglable').addClass('collapse');
      $('.left-side-links').find('.togglable').each(function () {
        $(this).attr('id', $(this).attr('data-id'));
      });
      $('.left-side-links').find('.togglable').removeAttr('data-id');
    } else {
      $('.left-side-links').find('.togglable').removeClass('collapse');
      $('.left-side-links').find('.togglable').each(function () {
        $(this).attr('data-id', $(this).attr('id'));
      });
      $('.left-side-links').find('.togglable').removeAttr('id');
    }
  });
  var faqAccordion = $('.sc-faq-accordion .card .togglable');
  if (faqAccordion.length > 0) {
    faqAccordion.on('shown.bs.collapse', function () {
      $(this).parent().find('h5').find('i').removeClass('gnv-icon-down-caret');
      $(this).parent().find('h5').find('i').addClass('gnv-icon-up-caret');
    });
    faqAccordion.on('hidden.bs.collapse', function () {
      $(this).parent().find('h5').find('i').addClass('gnv-icon-down-caret');
      $(this).parent().find('h5').find('i').removeClass('gnv-icon-up-caret');
    });
  }
  $("#meals-prices-routes").change(function () {
    $(".meals-prices-container  .meal-price").hide();
    $(".meals-prices-container  .meal-price.route-" + this.value).show();
  });
});

(function ($) {
  $(document).ready(function () {
    var selector = $('.js-makeSecondPartOfBlueGradient');
    if(selector.length > 0) {
      selector.each(function() {
        var el = $(this);
        var targetElement = el.attr('data-targetEl');
        if (targetElement !== undefined && targetElement !== null && targetElement !== '') {
          targetElement = $(targetElement);
          // if (targetElement.length > 0) {
          //   targetElement.addClass('from-blue-gradient-section blue-gradient-bg--reverse shape-and-ship-bg--bottom-spacing');
          // }
        }

      });
    }
  });
}(jQuery));
